export default __webpack_public_path__ + "static/media/foodiest_tm_logo.7d0530ca.svg";